import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { ManageSellersInterface } from '../interfaces/manage-sellers.interfaces'

export function ManageSellersContainer() {
  const navigate = useNavigate()
  const handleBackPage = () => {
    navigate('/relatorios')
  }

  return (
    <Layout pageTitle="Relatório Gerencial" handleGoBack={handleBackPage}>
      <ManageSellersInterface />
    </Layout>
  )
}
